import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SegmentsAppState } from './types';

const initialState: SegmentsAppState = {
  highlightedSegmentIds: [],
};

export const segmentsSlice = createSlice({
  name: 'segments',
  initialState,
  reducers: {
    highlightSegments: (state, action: PayloadAction<string[]>) => {
      state.highlightedSegmentIds = action.payload;
    },
  },
});

export const { highlightSegments } = segmentsSlice.actions;

export const segmentsReducer = segmentsSlice.reducer;
